export default __webpack_public_path__ + "static/media/world_light_black_outline.b35521a6.png";